import React, { useState } from "react";
import { requestPasswordReset } from "../services/passwordReset.service";
import "../styles/pages/ForgotPassword.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("");
    setError("");
    setLoading(true);
    try {
      await requestPasswordReset(email.trim());
      setStatus("If this email exists, reset instructions have been sent.");
    } catch (err) {
      setError(err.message || "Failed to request password reset");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-page">
      <div className="forgot-box">
        <h2>Forgot Password</h2>
        <p>Enter your registered email, and we’ll send you reset instructions.</p>

        <form onSubmit={handleSubmit}>
          <label>Email Address</label>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          {status && <div className="fp-success">{status}</div>}
          {error && <div className="fp-error">{error}</div>}

          <button type="submit" className="btn-reset" disabled={loading}>
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>
      </div>
    </div>
  );
}
